import * as React from "react";
import { Row, Col } from "antd";
import { Load } from "../../../lib/model/Load";
import { CompactLoadInput } from "./CompactLoadInput";
import { loadPresets } from "../../../lib/loadPresets";
import { removeItemAtIndex } from "../../../lib/helpers";

type Props = {
  loads: Load[];
  onLoadsChange: (loads: Load[]) => void;
};

export class CompactLoadInputList extends React.Component<Props> {
  render() {
    const { loads, onLoadsChange } = this.props;
    return (
      <>
        {loads.map((l, i) => (
          <Row type="flex" key={i} style={{ height: `${100 / loads.length}%` }} >
            <Col span={24}>
              <CompactLoadInput
                load={l}
                onUpdateLoad={load => {
                  const newLoads = [...loads];
                  newLoads[i] = load;
                  onLoadsChange(newLoads);
                }}
                onAddClicked={() => onLoadsChange([...loads, loadPresets[0]])}
                onRemoveClicked={() =>
                  onLoadsChange(removeItemAtIndex([...loads], i))
                }
                shouldShowRemoveButton={loads.length > 1}
                shouldShowAddButton={i === loads.length - 1}
                loadSuffix={loads.length < 2 ? undefined : `${i + 1}`}
              />
            </Col>
          </Row>
        ))}
      </>
    );
  }
}
